var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.localText.length)+"/"+_vm._s(_vm.length))])
}
var staticRenderFns = []

export { render, staticRenderFns }